// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/beleren-bold_P1.01.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/belerensmallcaps-bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/mplantin.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/mplantin.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/MPlantin-Italic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/MPlantin-Italic.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
@font-face {
	font-family: "Beleren";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
	font-family: "Beleren Small Caps";
	src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
	font-family: "MPlantin";
	src:
		url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("eot"),
		url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}
@font-face {
	font-family: "MPlantin-Italic";
	src:
		url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"),
		url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff2");
	font-style: italic;
}
.card-text-container[data-v-bf988c78] {
	position: absolute;
	aspect-ratio: 100/140;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;

	--bg-opacity: 0.3;
	--bg-color: rgba(0, 0, 0, var(--bg-opacity));
}
.battle-front .card-text-container[data-v-bf988c78] {
	top: 0;
	left: 14.5%;
	right: auto;
	bottom: 0;
}
.card-text-container[data-v-bf988c78] > * {
	flex: 1;
}
.color-W[data-v-bf988c78] {
	--bg-color: rgba(230, 231, 225, var(--bg-opacity));
}
.color-U[data-v-bf988c78] {
	--bg-color: rgba(14, 104, 171, var(--bg-opacity));
}
.color-B[data-v-bf988c78] {
	--bg-color: rgba(20, 10, 0, var(--bg-opacity));
}
.color-R[data-v-bf988c78] {
	--bg-color: rgba(160, 12, 22, var(--bg-opacity));
}
.color-G[data-v-bf988c78] {
	--bg-color: rgba(0, 110, 57, var(--bg-opacity));
}
.color-M[data-v-bf988c78] {
	--bg-color: rgba(0, 0, 0, var(--bg-opacity));
	/* --bg-color: rgba(134, 88, 0, var(--bg-opacity)); */
}
.card-text {
&[data-v-bf988c78] {
	position: relative;
	aspect-ratio: 100/140;
	z-index: 10;

	border-radius: 3%;
	background: radial-gradient(circle at 50% 35%, rgba(0, 0, 0, 0) 10%, var(--bg-color) 80%);
	direction: ltr;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;

	font-family: Beleren;
	}
& > div[data-v-bf988c78] {
		background-color: #222;
		overflow: hidden;
		border: solid 2px #666;
		box-sizing: border-box;
}
.card-top-line[data-v-bf988c78] {
		position: absolute;
		top: 2.5%;
		left: 3%;
		right: 3%;

		height: 7%;

		border-radius: 2% / 50%;
		padding: 0 2.6%;
}
.card-top-line-inner[data-v-bf988c78] {
		display: flex;
		justify-content: space-between;
		align-items: center;
		align-content: center;
		white-space: nowrap;
		width: 100%;
		height: 100%;
}
.card-name[data-v-bf988c78] {
		flex: 0 1 auto;
		max-height: 100%;
}
.card-mana-cost[data-v-bf988c78] {
		flex: 1 0 auto;

		display: inline-flex;
		justify-content: flex-end;
		align-items: stretch;
		gap: 2%;
		height: 60%;
		width: auto;
}
.card-canonical-name[data-v-bf988c78] {
		position: absolute;
		top: calc(9.5% - 2px);
		left: 8%;
		right: 8%;

		height: 4%;

		--clip: 3%;
		clip-path: polygon(var(--clip) 100%, calc(100% - var(--clip)) 100%, 100% 0, 0 0);
		padding: 0.25% calc(1% + var(--clip));

		text-align: center;
		max-height: 100%;
}
.card-type[data-v-bf988c78] {
		position: absolute;
		top: 56%;
		left: 3%;
		right: 3%;
		height: 7%;

		display: flex;
		justify-content: flex-start;
		white-space: nowrap;
		align-items: center;
		padding: 0.5% 4%;

		border-radius: 2% / 50%;

		font-size: 0.8em;
		z-index: 1;
}
.card-oracle[data-v-bf988c78] {
		position: absolute;
		top: 62.5%;
		left: 5.5%;
		right: 5.5%;
		bottom: 6%;

		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-start;
		gap: 0.2em;

		border-radius: 1%;

		padding: 2% 3%;
		text-align: left;
		font-size: 0.8em;
		font-family: MPlantin;
}
.card-loyalty[data-v-bf988c78],
	.card-pt[data-v-bf988c78] {
		position: absolute;
		width: 18%;
		height: 6%;
		right: 3%;
		bottom: 2%;
		z-index: 2;

		border-radius: 10% / 50%;

		display: flex;
		justify-content: center;
		align-items: center;
}
&[data-v-bf988c78] .mana-symbol {
		display: inline-block;
		width: 1em;
		border-radius: 50%;
}
.card-mana-cost[data-v-bf988c78] .mana-symbol {
		box-shadow: -0.14vh 0.14vh 0 rgba(0, 0, 0, 0.85);
		width: auto;
}
.card-oracle[data-v-bf988c78] .mana-symbol {
		width: 0.8em;
		margin: 0 0.07em;
		vertical-align: baseline;
}
.card-oracle[data-v-bf988c78] .oracle-reminder {
		font-family: MPlantin-Italic;
		font-style: italic;
}
}
`, "",{"version":3,"sources":["webpack://./client/src/components/CardText.vue","<no source>"],"names":[],"mappings":";AA2JA;CACC,sBAAsB;CACtB,+DAAqE;AACtE;AACA;CACC,iCAAiC;CACjC,+DAAwE;AACzE;AACA;CACC,uBAAuB;CACvB;;wDAEoD;AACrD;AACA;CACC,8BAA8B;CAC9B;;yDAE6D;CAC7D,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,aAAa;;CAEb,iBAAiB;CACjB,4CAA4C;AAC7C;AAEA;CACC,MAAM;CACN,WAAW;CACX,WAAW;CACX,SAAS;AACV;AAEA;CACC,OAAO;AACR;AAEA;CACC,kDAAkD;AACnD;AACA;CACC,iDAAiD;AAClD;AACA;CACC,8CAA8C;AAC/C;AACA;CACC,gDAAgD;AACjD;AACA;CACC,+CAA+C;AAChD;AACA;CACC,4CAA4C;CAC5C,qDAAqD;AACtD;AAEA;AC7NA;CD8NC,kBAAkB;CAClB,qBAAqB;CACrB,WAAW;;CAEX,iBAAiB;CACjB,yFAAyF;CACzF,cAAc;CACd,yBAAyB;CACzB,sBAAsB;CACtB,qBAAqB;CACrB,iBAAiB;;CAEjB,oBAAA;CA7JA;AA+JA;EACC,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACvB;AAEA;EACC,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,SAAS;;EAET,UAAU;;EAEV,uBAAuB;EACvB,eAAe;AAChB;AAEA;EACC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACb;AAEA;EACC,cAAc;EACd,gBAAgB;AACjB;AAEA;EACC,cAAc;;EAEd,oBAAoB;EACpB,yBAAyB;EACzB,oBAAoB;EACpB,OAAO;EACP,WAAW;EACX,WAAW;AACZ;AAEA;EACC,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,SAAS;;EAET,UAAU;;EAEV,UAAU;EACV,gFAAgF;EAChF,qCAAqC;;EAErC,kBAAkB;EAClB,gBAAgB;AACjB;AAEA;EACC,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,UAAU;;EAEV,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;;EAEhB,uBAAuB;;EAEvB,gBAAgB;EAChB,UAAU;AACX;AAEA;EACC,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,WAAW;EACX,UAAU;;EAEV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,UAAU;;EAEV,iBAAiB;;EAEjB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACtB;AAEA;;EAEC,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,SAAS;EACT,UAAU;EACV,UAAU;;EAEV,wBAAwB;;EAExB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACpB;AAEA;EACC,qBAAqB;EACrB,UAAU;EACV,kBAAkB;AACnB;AAEA;EACC,gDAAgD;EAChD,WAAW;AACZ;AAEA;EACC,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;AACzB;AACA;EACC,4BAA4B;EAC5B,kBAAkB;AACnB;AACD","sourcesContent":["<template>\n\t<div class=\"card-text-container\" ref=\"rootElement\">\n\t\t<template v-if=\"!face\">\n\t\t\t<div>\n\t\t\t\t<font-awesome-icon icon=\"fa-solid fa-spinner\" spin />\n\t\t\t</div>\n\t\t</template>\n\t\t<template v-else>\n\t\t\t<div class=\"card-text\" :class=\"'color-' + backColor\">\n\t\t\t\t<div class=\"card-top-line\" v-if=\"printed_name\">\n\t\t\t\t\t<div class=\"card-top-line-inner\">\n\t\t\t\t\t\t<div class=\"card-name font-size-fit\">{{ printed_name }}</div>\n\t\t\t\t\t\t<div class=\"card-mana-cost\">\n\t\t\t\t\t\t\t<img v-for=\"(s, idx) in manaCost\" :key=\"idx\" :src=\"s.svg_uri\" class=\"mana-symbol\" />\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"card-canonical-name font-size-fit\" v-if=\"canonical_name\">{{ canonical_name }}</div>\n\t\t\t\t<div class=\"card-type font-size-fit\" v-if=\"face.type_line\">\n\t\t\t\t\t{{ face.type_line }}\n\t\t\t\t</div>\n\t\t\t\t<div\n\t\t\t\t\tclass=\"card-oracle font-size-fit\"\n\t\t\t\t\tv-if=\"face.oracle_text\"\n\t\t\t\t\tv-html=\"parseOracle(face.oracle_text)\"\n\t\t\t\t></div>\n\t\t\t\t<div class=\"card-pt font-size-fit\" v-if=\"face.power\">{{ face.power }} / {{ face.toughness }}</div>\n\t\t\t\t<div class=\"card-loyalty font-size-fit\" v-if=\"face.loyalty\">{{ face.loyalty }}</div>\n\t\t\t</div>\n\t\t</template>\n\t</div>\n</template>\n\n<script setup lang=\"ts\">\nimport { ScryfallCard, isScryfallCard, ScryfallCardFace, CardCacheEntry, isScryfallCardFace } from \"../vueCardCache\";\nimport { ref, computed, watch, onMounted, nextTick, onUnmounted } from \"vue\";\nimport { replaceManaSymbols, parseManaSymbols } from \"../ManaSymbols\";\nimport { Card, CardFace } from \"@/CardTypes\";\nimport { fitFontSize } from \"../helper\";\n\n// Displays a card using Scryfall card data instead of its image.\nconst props = withDefaults(\n\tdefineProps<{\n\t\tcard: ScryfallCard | ScryfallCardFace | CardCacheEntry | CardFace | Card;\n\t\tfixedLayout?: boolean;\n\t\tdelayTextFit?: boolean;\n\t}>(),\n\t{ fixedLayout: false, delayTextFit: false }\n);\n\nconst rootElement = ref<HTMLElement>();\n\nlet idleRequest: number | undefined = undefined;\n\nonMounted(() => {\n\t// This has to be called when the component is visible:\n\t// We can't use v-show or mounted will be called while the element is hidden and fitAll will do nothing.\n\t// There's no way to know when the element is visible becasue of v-show (apart from tracking it ourselves).\n\t// NOTE: Fitting a lot of cards simultaneously is very slow in Chrome (e.g. for a cube list). delayTextFit is a hack to stagger these calls and not block the main thread.\n\tif (props.delayTextFit && window.requestIdleCallback) idleRequest = window.requestIdleCallback(fitAll);\n\telse fitAll();\n});\n\nonUnmounted(() => {\n\tif (idleRequest) window.cancelIdleCallback(idleRequest);\n});\n\nfunction fitAll() {\n\tnextTick(() => {\n\t\trootElement.value?.querySelectorAll(\".card-text .font-size-fit\").forEach((div) => {\n\t\t\tfitFontSize(div as HTMLElement, 2.5, \"vh\");\n\t\t});\n\t});\n}\n\nfunction parseOracle(str: string) {\n\tstr = replaceManaSymbols(str);\n\t// Included reminder text\n\tstr = str.replace(/\\([^)]+\\)/g, (match) => `<span class=\"oracle-reminder\">${match}</span>`);\n\treturn str\n\t\t.split(\"\\n\")\n\t\t.map((line) => `<div>${line}</div>`)\n\t\t.join(\"\");\n}\n\nconst manaCost = computed(() => {\n\tif (!face.value?.mana_cost) return [];\n\treturn parseManaSymbols(face.value.mana_cost);\n});\n\nconst colors = computed(() => {\n\tif (!props.card) return undefined;\n\tif (isScryfallCard(props.card)) {\n\t\treturn props.card.colors;\n\t} else if (isScryfallCardFace(props.card)) {\n\t\treturn props.card.colors;\n\t}\n\tif (\"colors\" in props.card) return props.card.colors;\n\treturn undefined;\n});\n\nconst backColor = computed(() => {\n\tif (!colors.value) return undefined;\n\tif (colors.value?.length === 1) return colors.value[0];\n\treturn \"M\";\n});\n\nconst face = computed(() => {\n\tif (!props.card) return undefined;\n\tif (isScryfallCard(props.card)) {\n\t\tif (!props.card?.card_faces || props.card?.card_faces?.length <= 1) return props.card;\n\t\treturn props.card.card_faces[0];\n\t} else if (isScryfallCardFace(props.card)) {\n\t\treturn props.card;\n\t}\n\tconst r: Partial<ScryfallCardFace> = {};\n\tif (\n\t\t\"printed_names\" in props.card &&\n\t\tprops.card.printed_names?.[\"en\"] &&\n\t\tprops.card.printed_names[\"en\"] !== props.card.name\n\t) {\n\t\tr.printed_name = props.card.printed_names[\"en\"];\n\t}\n\tif (\"name\" in props.card) r.name = props.card.name;\n\tif (\"mana_cost\" in props.card) r.mana_cost = props.card.mana_cost;\n\tif (\"type\" in props.card) {\n\t\tr.type_line = props.card.type;\n\t\tif (\"subtypes\" in props.card && props.card.subtypes.length > 0)\n\t\t\tr.type_line += \" \\u2013 \" + props.card.subtypes.join(\" \");\n\t}\n\tif (\"oracle_text\" in props.card) r.oracle_text = props.card.oracle_text;\n\tif (\"power\" in props.card) r.power = props.card.power?.toString();\n\tif (\"toughness\" in props.card) r.toughness = props.card.toughness?.toString();\n\tif (\"loyalty\" in props.card) r.loyalty = props.card.loyalty?.toString();\n\treturn r;\n});\n\nconst printed_name = computed(() => {\n\tif (!face.value) return undefined;\n\tif (\"printed_name\" in face.value) return face.value.printed_name;\n\treturn face.value.name;\n});\n\nconst canonical_name = computed(() => {\n\tif (!face.value) return undefined;\n\tif (\"printed_name\" in face.value) return face.value.name;\n\treturn undefined;\n});\n\nwatch(face, () => {\n\tfitAll();\n});\n</script>\n\n<style scoped>\n@font-face {\n\tfont-family: \"Beleren\";\n\tsrc: url(\"../assets/fonts/beleren-bold_P1.01.ttf\") format(\"truetype\");\n}\n@font-face {\n\tfont-family: \"Beleren Small Caps\";\n\tsrc: url(\"../assets/fonts/belerensmallcaps-bold.ttf\") format(\"truetype\");\n}\n@font-face {\n\tfont-family: \"MPlantin\";\n\tsrc:\n\t\turl(\"../assets/fonts/mplantin.eot\") format(\"eot\"),\n\t\turl(\"../assets/fonts/mplantin.woff\") format(\"woff\");\n}\n@font-face {\n\tfont-family: \"MPlantin-Italic\";\n\tsrc:\n\t\turl(\"../assets/fonts/MPlantin-Italic.woff\") format(\"woff\"),\n\t\turl(\"../assets/fonts/MPlantin-Italic.woff2\") format(\"woff2\");\n\tfont-style: italic;\n}\n\n.card-text-container {\n\tposition: absolute;\n\taspect-ratio: 100/140;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tdisplay: flex;\n\n\t--bg-opacity: 0.3;\n\t--bg-color: rgba(0, 0, 0, var(--bg-opacity));\n}\n\n.battle-front .card-text-container {\n\ttop: 0;\n\tleft: 14.5%;\n\tright: auto;\n\tbottom: 0;\n}\n\n.card-text-container > * {\n\tflex: 1;\n}\n\n.color-W {\n\t--bg-color: rgba(230, 231, 225, var(--bg-opacity));\n}\n.color-U {\n\t--bg-color: rgba(14, 104, 171, var(--bg-opacity));\n}\n.color-B {\n\t--bg-color: rgba(20, 10, 0, var(--bg-opacity));\n}\n.color-R {\n\t--bg-color: rgba(160, 12, 22, var(--bg-opacity));\n}\n.color-G {\n\t--bg-color: rgba(0, 110, 57, var(--bg-opacity));\n}\n.color-M {\n\t--bg-color: rgba(0, 0, 0, var(--bg-opacity));\n\t/* --bg-color: rgba(134, 88, 0, var(--bg-opacity)); */\n}\n\n.card-text {\n\tposition: relative;\n\taspect-ratio: 100/140;\n\tz-index: 10;\n\n\tborder-radius: 3%;\n\tbackground: radial-gradient(circle at 50% 35%, rgba(0, 0, 0, 0) 10%, var(--bg-color) 80%);\n\tdirection: ltr;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\n\tfont-family: Beleren;\n\n\t& > div {\n\t\tbackground-color: #222;\n\t\toverflow: hidden;\n\t\tborder: solid 2px #666;\n\t\tbox-sizing: border-box;\n\t}\n\n\t.card-top-line {\n\t\tposition: absolute;\n\t\ttop: 2.5%;\n\t\tleft: 3%;\n\t\tright: 3%;\n\n\t\theight: 7%;\n\n\t\tborder-radius: 2% / 50%;\n\t\tpadding: 0 2.6%;\n\t}\n\n\t.card-top-line-inner {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\talign-items: center;\n\t\talign-content: center;\n\t\twhite-space: nowrap;\n\t\twidth: 100%;\n\t\theight: 100%;\n\t}\n\n\t.card-name {\n\t\tflex: 0 1 auto;\n\t\tmax-height: 100%;\n\t}\n\n\t.card-mana-cost {\n\t\tflex: 1 0 auto;\n\n\t\tdisplay: inline-flex;\n\t\tjustify-content: flex-end;\n\t\talign-items: stretch;\n\t\tgap: 2%;\n\t\theight: 60%;\n\t\twidth: auto;\n\t}\n\n\t.card-canonical-name {\n\t\tposition: absolute;\n\t\ttop: calc(9.5% - 2px);\n\t\tleft: 8%;\n\t\tright: 8%;\n\n\t\theight: 4%;\n\n\t\t--clip: 3%;\n\t\tclip-path: polygon(var(--clip) 100%, calc(100% - var(--clip)) 100%, 100% 0, 0 0);\n\t\tpadding: 0.25% calc(1% + var(--clip));\n\n\t\ttext-align: center;\n\t\tmax-height: 100%;\n\t}\n\n\t.card-type {\n\t\tposition: absolute;\n\t\ttop: 56%;\n\t\tleft: 3%;\n\t\tright: 3%;\n\t\theight: 7%;\n\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\twhite-space: nowrap;\n\t\talign-items: center;\n\t\tpadding: 0.5% 4%;\n\n\t\tborder-radius: 2% / 50%;\n\n\t\tfont-size: 0.8em;\n\t\tz-index: 1;\n\t}\n\n\t.card-oracle {\n\t\tposition: absolute;\n\t\ttop: 62.5%;\n\t\tleft: 5.5%;\n\t\tright: 5.5%;\n\t\tbottom: 6%;\n\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\talign-items: flex-start;\n\t\tgap: 0.2em;\n\n\t\tborder-radius: 1%;\n\n\t\tpadding: 2% 3%;\n\t\ttext-align: left;\n\t\tfont-size: 0.8em;\n\t\tfont-family: MPlantin;\n\t}\n\n\t.card-loyalty,\n\t.card-pt {\n\t\tposition: absolute;\n\t\twidth: 18%;\n\t\theight: 6%;\n\t\tright: 3%;\n\t\tbottom: 2%;\n\t\tz-index: 2;\n\n\t\tborder-radius: 10% / 50%;\n\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t}\n\n\t& :deep(.mana-symbol) {\n\t\tdisplay: inline-block;\n\t\twidth: 1em;\n\t\tborder-radius: 50%;\n\t}\n\n\t.card-mana-cost :deep(.mana-symbol) {\n\t\tbox-shadow: -0.14vh 0.14vh 0 rgba(0, 0, 0, 0.85);\n\t\twidth: auto;\n\t}\n\n\t.card-oracle :deep(.mana-symbol) {\n\t\twidth: 0.8em;\n\t\tmargin: 0 0.07em;\n\t\tvertical-align: baseline;\n\t}\n\t.card-oracle :deep(.oracle-reminder) {\n\t\tfont-family: MPlantin-Italic;\n\t\tfont-style: italic;\n\t}\n}\n</style>\n",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
